import { z } from 'zod'
import { CrbMonitorListPayload } from '~bank-crb-monitor/types'

export const CrbMonitorListSchema = z.object({
  allRelationships: z.boolean().optional().nullable(),
  connectionStatus: z.string().optional().nullable(),
  customerStatus: z.string().optional().nullable(),
  crbLicenseStatus: z.string().optional().nullable(),
  licenseId: z.number().int().nonnegative().optional().nullable(),
  onlyAlerted: z.boolean().optional().nullable(),
  onlyDisconnected: z.boolean().optional().nullable(),
  assignedRelationshipsOnly: z.boolean().default(true),
  sortDesc: z.boolean().optional().nullable(),
  searchTerm: z.string().optional().nullable(),
  sortBy: z.string().optional().nullable(),
  page: z.number().int().nonnegative().optional(),
  relationshipId: z.number().int().nonnegative().optional().nullable(),
  size: z.number().int().nonnegative().optional()
}) as z.ZodType<CrbMonitorListPayload>
